import {LogLevel} from "../../services/logger/log-level.enum";

export class FrontendErrorDto {

  public level: LogLevel | undefined;
  public message: string | undefined;
  public clazz: string | undefined;
  public type: string | undefined;
  public code: string | number | undefined;
  public orgId: string | undefined;

  constructor(init?: Partial<FrontendErrorDto>) {
    Object.assign(this, init);
  }
}
